const FEATURE_HELP_URLS = {
  agent_bots: 'https://ezyaa.de/',
  agents: 'https://ezyaa.de/',
  audit_logs: 'https://ezyaa.de/',
  campaigns: 'https://ezyaa.de/',
  canned_responses: 'https://ezyaa.de/',
  channel_email: 'https://ezyaa.de/',
  channel_facebook: 'https://ezyaa.de/',
  custom_attributes: 'https://ezyaa.de/',
  dashboard_apps: 'https://ezyaa.de/',
  help_center: 'https://ezyaa.de/',
  inboxes: 'https://ezyaa.de/',
  integrations: 'https://ezyaa.de/',
  labels: 'https://ezyaa.de/',
  macros: 'https://ezyaa.de/',
  message_reply_to: 'https://ezyaa.de/',
  reports: 'https://ezyaa.de/',
  sla: 'https://ezyaa.de/',
  team_management: 'https://ezyaa.de/',
  webhook: 'https://ezyaa.de/',
  billing: 'https://ezyaa.de/',
  saml: 'https://ezyaa.de/',
  captain_billing: 'https://ezyaa.de/',
};

export function getHelpUrlForFeature(featureName) {
  return FEATURE_HELP_URLS[featureName];
}
